"use client";

import { Toaster as Sonner, type ToasterProps } from "sonner";

// Shadcn-style toaster wrapper. Kya doesn't expose a theme provider yet,
// so we hard-code "light" here; swap to `next-themes` if dark mode lands.
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-neutral-11 group-[.toaster]:border-[#eee] group-[.toaster]:shadow-1",
          description: "group-[.toast]:text-neutral-07",
          actionButton:
            "group-[.toast]:bg-neutral-10 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#f6f6f6] group-[.toast]:text-neutral-07",
        },
      }}
      {...props}
    />
  );
}
